import * as types from '../types'

export default ({
  state: {
    title: '',
    websocketPort: 0,
  },
  getters: {
    title: state => state.title,
    websocketPort: state => state.websocketPort,
  },
  mutations: {
    [types.TITLE](state, res) {
      state.title = res
    },
    [types.WEBSOCKET_PORT](state, res) {
      state.websocketPort = res
    },    
  },
  actions: {
    setSiteConfig({ commit }, params) {     
      commit(types.TITLE, params.title);
      commit(types.WEBSOCKET_PORT, params.websocket_port);
    },
  }
})